import { render } from "./TheWatchSymbolButton.vue?vue&type=template&id=cf08bae6&ts=true"
import script from "./TheWatchSymbolButton.vue?vue&type=script&lang=ts"
export * from "./TheWatchSymbolButton.vue?vue&type=script&lang=ts"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__